import { useState } from "react"

const useAppState = () => {
  const [insured, setInsured] = useState({
    name: '',
    nricPassport: '',
    bizRegNo: '',
    dateOfBirth: '',
    gender: '',
    email: '',
    mobile: '',
    marital: '',
    address1: '',
    address2: '',
    address3: '',
    postcode: '',
    city: '',
    addState: '',
    type: 'P',
    occpCode: '',
    typeOfBusiness: '',
    nationality: '',
    sstNo: '',
    tin: '',
    isNric: false
  });

  const [vehicle, setVehicle] = useState({
    registrationNo: '',
    year: '',
    make: '',
    model: '',
    variants: [],
    // variant: {},
    nvic: '',
    engineNo: '',
    chassisNo: '',
    cc: '',
    region: '',
    useOfVehicle: '',
    sumInsured: 0,
    sumInsuredOptions: [],
    financing: '',
    loanCompany: '',
    claimsAtFault: 0,
    windscreenClaims: 0,
    allowWindscreen: "Y"
  })

  const [quotation, setQuotation] = useState({
    // product: { value: 'sm', label: 'SOMPO MotorNow' },
    // coverageType: 'sm',
    product: { value: 'ssm', label: 'Secure Motor (Staff)' },
    coverageType: 'ssm',
    basicPremium: 0,
    ncdPercent: 0,
    ncdAmount: 0,
    totalBasePremium: 0,
    grossPremium: 0,
    rebatePercent: 10,
    rebateAmount: 0,
    sstPercent: 0,
    sstAmount: 0,
    stampDuty: 0,
    totalPremium: 0,
    inceptionDate: '',
    expiryDate: '',
    extraCoverageAmount: 0,
    // normalTotalPremium: 0,
    // excessTotalPremium: 0,
    // tpftTotalPremium: 0,
    covernoteNo: '',
    partner: '',
    isAgreedValue: false
  })

  const [normalTotalPremium, setNormalTotalPremium] = useState(0)
  const [excessTotalPremium, setExcessTotalPremium] = useState(0)
  const [tpftTotalPremium, setTpftTotalPremium] = useState(0)

  const [isQuotationRefreshed, setIsQuotationRefreshed] = useState(true)

  // const [veQuotation, setVEQuotation] = useState({
  // 	product: { value: 'mnve', label: 'SOMPO MotorNow' },
  // 	coverageType: 'mnve',
  // 	basicPremium: 0,
  // 	ncdPercent: 0,
  // 	ncdAmount: 0,
  // 	totalBasePremium: 0,
  // 	grossPremium: 0,
  // 	rebatePercent: 10,
  // 	rebateAmount: 0,
  // 	sstPercent: 0,
  // 	sstAmount: 0,
  // 	stampDuty: 0,
  // 	totalPremium: 0,
  // 	inceptionDate: '',
  //   expiryDate: ''
  // })

  // const [tpftQuotation, setTPFTQuotation] = useState({
  // 	product: { value: 'tpft', label: 'SOMPO MotorNow' },
  // 	coverageType: 'tpft',
  // 	basicPremium: 0,
  // 	ncdPercent: 0,
  // 	ncdAmount: 0,
  // 	totalBasePremium: 0,
  // 	grossPremium: 0,
  // 	rebatePercent: 10,
  // 	rebateAmount: 0,
  // 	sstPercent: 0,
  // 	sstAmount: 0,
  // 	stampDuty: 0,
  // 	totalPremium: 0,
  // 	inceptionDate: '',
  // 	expiryDate: ''
  // })

  const [sumInsureds, setSumInsureds] = useState([])

  const [addons, setAddons] = useState([
    {
      CODE: "89A",
      SUM_INSURED: 1000,
      PREMIUM: "50"
    },
    {
      CODE: "TOWP",
      PREMIUM: "50"
    },
    {
      CODE: "SPTP",
      PREMIUM: "50"
    },
    {
      CODE: "112",
      PREMIUM: "50",
      CART_DAYS: 7,
      CART_AMOUNT: 50
    },
    {
      CODE: "PLC",
      PREMIUM: "50"
    },
    {
      CODE: "72",
      PREMIUM: "50"
    },
    {
      CODE: "EHRP",
      PREMIUM: "50"
    },
    {
      CODE: "111",
      PREMIUM: "50"
    },
    {
      CODE: "BTWP",
      PREMIUM: "50"
    },
    {
      CODE: "97A",
      SUM_INSURED: 1000,
      PREMIUM: "50"
    },
    {
      CODE: "25",
      PREMIUM: "50"
    },
  ])

  const [cart, setCart] = useState("750")
  const [autoloan, setAutoLoan] = useState("AL1P")
  const [loup, setLoup] = useState("LOUP10")
  const [paPlan, setPAPlan] = useState("PA2P")

  const [isCurrentTPFT, setIsCurrentTPFT] = useState(false)

  const [selectedAddons, setSelectedAddons] = useState([])

  const [isAddonsLoad, setIsAddonsLoad] = useState(false)
  const [isExcessLoad, setIsExcessLoad] = useState(false)
  const [isTpftLoad, setIsTpftLoad] = useState(false)

  const [promoCode, setPromoCode] = useState('')

  const [bundleCode, setBundleCode] = useState('')
  const [bundlePremium, setBundlePremium] = useState(0)

  const [showResults, setShowResults] = useState(false)
  const [corAddress, setCorAddress] = useState(false)
  const [contactNo, setContactNo] = useState(false)
  const [occp, setOccp] = useState(false)
  const [showMaintenance, setShowMaintenance] = useState({title: "", message: ""});

  const handleVehicle = ({ make, model }) => {
    let state = {}
    if (make !== vehicle.make) {
      state.make = make
      state.model = ''
    }

    setVehicle({
      ...vehicle,
      ...state
    })
  }

  const reduceInsured = state => {
    const { nricPassport } = state
    let dateOfBirth = state.dateOfBirth || insured.dateOfBirth
    let gender = state.gender || insured.gender
    let isNric = insured.isNric
    let nationality = state.nationality || insured.nationality
    if (nricPassport) {
      const strippedNric = nricPassport.replace(/-/g, '')
      if (strippedNric.length === 12 && /^\d+$/.test(strippedNric)) {
        isNric = true
        const baseYear = 1900
        const currentYear = new Date().getFullYear()
        const maxAge = 90
        let year = baseYear + parseInt(nricPassport.substr(0, 2))
        if (currentYear - year >= maxAge) year += 100
        const month = parseInt(nricPassport.substr(2, 2))
        const day = parseInt(nricPassport.substr(4, 2))
        dateOfBirth = new Date(year, month - 1, day)
        if (!state.gender) {
          const lastDigitNric = parseInt(nricPassport.substr(-1))
          gender = lastDigitNric % 2 === 0 ? 'F' : 'M'
        }
        nationality = 'MYS'
      }
    }

    setInsured({
      ...insured,
      ...state,
      dateOfBirth,
      gender,
      nationality,
      isNric
    })
  }

  const reduceVehicle = state => {
    // if (state.sumInsured) {
    //   setSumInsureds([
    //     state.sumInsured * 0.9,
    //     state.sumInsured * 0.95,
    //     state.sumInsured
    //   ])
    // }

    setVehicle({
      ...vehicle,
      ...state
    })
  }

  const reduceQuotation = state => {
    setQuotation({
      ...quotation,
      ...state
    })
  }

  // const reduceAddons = state => {
  // 	setAddons({
  // 		...addons,
  // 		...state
  // 	})
  // }
  const [language, setLanguage] = useState('en')
  const [isNewSSMId, setIsNewSSMId] = useState(false)
  const [tin, setTin] = useState('')

  return {
    insured,
    setInsured: reduceInsured,
    vehicle,
    setVehicle: reduceVehicle,
    handleVehicle,
    quotation,
    setQuotation: reduceQuotation,
    normalTotalPremium,
    setNormalTotalPremium,
    excessTotalPremium,
    setExcessTotalPremium,
    tpftTotalPremium,
    setTpftTotalPremium,
    isQuotationRefreshed,
    setIsQuotationRefreshed,
    sumInsureds,
    setSumInsureds,
    addons,
    setAddons: setAddons,
    selectedAddons,
    setSelectedAddons,
    cart,
    setCart,
    isCurrentTPFT,
    setIsCurrentTPFT,
    isAddonsLoad,
    setIsAddonsLoad,
    isExcessLoad,
    setIsExcessLoad,
    isTpftLoad,
    setIsTpftLoad,
    promoCode,
    setPromoCode,
    paPlan,
    setPAPlan,
    bundleCode,
    setBundleCode,
    bundlePremium,
    setBundlePremium,
    autoloan,
    setAutoLoan,
    loup,
    setLoup,
    showResults,
    setShowResults,
    corAddress,
    setCorAddress,
    contactNo,
    setContactNo,
    occp,
    setOccp,
    language,
    setLanguage,
    tin,
    setTin,
    showMaintenance, setShowMaintenance,
    isNewSSMId,
    setIsNewSSMId
  }
}

export default useAppState